import _util from '../../utils/';

const employeeEmailService = {
    AddEmployeeEmail(posts, resolve, reject) {
		_util.request({
			url: '/api/HREmployeeEmail/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
    },
    fetchEmployeeEmailDetail (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployeeEmail/DetailsByEmployeeId',
            params: params,
            success: resolve,
            error: reject
        })
    },
}

export default employeeEmailService


// WEBPACK FOOTER //
// ./src/services/Employee/employee-email-service.js